'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosToggleOutline = function IoIosToggleOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm7.5 25c-2 0-3.7 1.7-3.7 3.8s1.7 3.7 3.7 3.7 3.8-1.7 3.8-3.7-1.8-3.8-3.8-3.8z m0-1.2c2.7 0 5 2.2 5 5s-2.3 5-5 5-5-2.3-5-5 2.3-5 5-5z m19.9-1.3h-19.9c-3.4 0-6.2 2.8-6.2 6.3s2.8 6.2 6.2 6.2h20c3.4 0 6.3-2.8 6.3-6.2s-2.9-6.3-6.4-6.3z m0.1-1.2c4.1 0 7.5 3.3 7.5 7.5s-3.4 7.5-7.5 7.5h-20c-4.1 0-7.5-3.4-7.5-7.5s3.4-7.5 7.5-7.5h20z m0-13.8c-2 0-3.7 1.7-3.7 3.8s1.7 3.7 3.7 3.7 3.8-1.7 3.8-3.7-1.8-3.8-3.8-3.8z m0-1.2c2.7 0 5 2.2 5 5s-2.3 5-5 5-5-2.3-5-5 2.3-5 5-5z m-19.9-1.3c-3.5 0-6.3 2.8-6.3 6.3s2.8 6.2 6.2 6.2h20c3.4 0 6.3-2.8 6.3-6.2s-2.9-6.3-6.3-6.3h-19.9z m-0.1-1.2h20c4.1 0 7.5 3.3 7.5 7.5s-3.4 7.5-7.5 7.5h-20c-4.1 0-7.5-3.4-7.5-7.5s3.4-7.5 7.5-7.5z' })
        )
    );
};

exports.default = IoIosToggleOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-toggle-outline.js
// module id = 2788
// module chunks = 168707334958949